import Frame from "../Frame";
import { getFrameAbsoluteUrl } from "../resourceUrls";
import applyStyles from "../dom/applyStyles";
import { strings } from "@securionpay-internal/commons-js";
import { COMPANY_NAME } from "../../env";

export default class CheckoutFrame extends Frame {
    constructor(controllerId: string, options: object) {
        super(getFrameAbsoluteUrl('checkout/checkout.html'), controllerId, {options});
    }

    _createIframe(params: any): HTMLIFrameElement {
        const iframe = super._createIframe(params);
        iframe.setAttribute('title', 'checkout');
        applyStyles(iframe, {
            border: "none",
            margin: "0",
            padding: "0",
            width: "1px",
            "min-width": "100%",
            overflow: "hidden",
            display: "block",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0
        });
        return iframe;
    }

    _generateId(): string {
        return strings.unique(`__private${COMPANY_NAME}CheckoutFrame`);
    }
}
